module.exports = __webpack_public_path__ + "img/history_gallery_3.48775c4a.png";